import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function usuario(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@usuario/FIND_USUARIO':
      case '@usuario/UPDATE_USUARIO':
      case '@usuario/DELETE_USUARIO':
      case '@usuario/STORE_USUARIO':
      case '@usuario/USUARIOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@usuario/SUCCESS_REMOVE':
      case '@usuario/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@usuario/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.usuarios;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@usuario/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.usuario;
        break;
      }

      case '@usuario/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
